<template>
  <div class="container">
    <a-form-model
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="项目名称" prop="project_id" ref="project_id">
        <a-select
          style="width:300px"
          showSearch
          :filterOption="filterOption"
          optionFilterProp="children"
          v-model="ruleForm.project_id"
          @change="onSelectedPro"
          placeholder="请选择项目"
        >
          <a-select-option
            v-for="(item, i) in proList"
            :key="i"
            :value="item.id"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="出库网点" prop="device_id" ref="device_id">
        <a-select
          showSearch
          :filterOption="filterOption"
          optionFilterProp="children"
          style="width:300px"
          placeholder="请选择网点设备"
          v-model="ruleForm.device_id"
        >
          <a-select-option
            v-for="(item, i) in deviceList"
            :key="i"
            :value="item.device_id"
            >{{ item.device_name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="员工姓名" prop="user_id">
        <a-select
          style="width: 70%; margin-right: 10px"
          placeholder="请选择员工"
          show-search
          :filter-option="filterOption"
          v-model="ruleForm.user_id"
        >
          <a-select-option
            v-for="(item, i) in workerList"
            :key="i"
            :value="item.id"
            >{{ item.user_name + "&nbsp;" + item.phone }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="补货费用/次" prop="price">
        <a-input-number v-model="ruleForm.price" />
        <span>&nbsp;&nbsp;元</span>
      </a-form-model-item>
      <a-form-model-item label="上新费用/次" prop="new_price">
        <a-input-number v-model="ruleForm.new_price" />
        <span>&nbsp;&nbsp;元</span>
      </a-form-model-item>
      <a-form-model-item label="美陈费用/次" prop="pretty_price">
        <a-input-number v-model="ruleForm.pretty_price" />
        <span>&nbsp;&nbsp;元</span>
      </a-form-model-item>
      <a-form-model-item label="是否为默认收货人" prop="is_default">
        <a-radio-group v-model="ruleForm.is_default">
          <a-radio :value="1">不是</a-radio>
          <a-radio :value="2">是</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item> </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 12, offset: 5 }">
        <a-button style="margin-right: 10px" @click="resetForm('ruleForm')">
          重置
        </a-button>
        <a-button type="primary" @click="submitForm('ruleForm')">
          提交
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      moment,
      labelCol: { span: 5 },
      wrapperCol: { span: 12 },
      ruleForm: {
        project_id: "",
        device_id: "",
        user_id: "",
        price: "",
        new_price: "",
        pretty_price: "",
        is_default: ""
      },
      rules: {
        project_id: [
          { required: true, message: "请选择项目", trigger: "change" }
        ],
        device_id: [
          { required: true, message: "请选择出库网点", trigger: "change" }
        ],
        user_id: [{ required: true, message: "请选择员工", trigger: "change" }],
        price: [{ required: true, message: "请填写补货价格", trigger: "blur" }],
        new_price: [
          { required: true, message: "请填写上新价格", trigger: "blur" }
        ],
        pretty_price: [
          { required: true, message: "请填写美陈价格", trigger: "blur" }
        ],
        is_default: [
          {
            required: true,
            message: "请选择是否为默认收货人",
            trigger: "change"
          }
        ]
      },
      proList: [],
      deviceList: [],
      workerList: []
    };
  },
  mounted() {
    this.getPro(); //获取项目
    if (this.editDetail != undefined) {
      this.getDetail();
    }
  },
  props: {
    editDetail: {}
  },
  watch: {
    editDetail() {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      //   console.log(this.editDetail);
      this.ruleForm = {
        project_id: this.editDetail.project_id,
        device_id: this.editDetail.device_id,
        user_id: this.editDetail.user_id,
        price: this.editDetail.price,
        new_price: this.editDetail.new_price,
        pretty_price: this.editDetail.pretty_price,
        is_default: this.editDetail.is_default
      };
      this.getDeviceList(this.editDetail.project_id, false); //获取设备列表
      this.getWorker(this.editDetail.project_id); //获取员工
    },
    getWorker(proID) {
      let url =
        this.httpsBasic.url + this.httpsBasic.equipment + "Guard/guardList";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: proID,
          per_page: 10000
        })
        .then(res => {
          if (res.data.code == 200) {
            this.workerList = res.data.data.data;
            // console.log(this.workerList);
          }
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onSelectedPro(id) {
      this.getDeviceList(id, true); //获取设备列表
      this.getWorker(id); //获取员工
    },
    getDeviceList(id, msg) {
      if (msg) {
        this.ruleForm.device_id = "";
      }
      let url =
        this.httpsBasic.url + this.httpsBasic.equipment + "Device/getListData";
      let params = {
        project_id: id,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.deviceList = res.data.data;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    getPro() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/projectList";
      axios
        .post(url, {
          current_page: 1,
          per_page: 10000,
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 2
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let url =
            this.httpsBasic.url +
            this.httpsBasic.equipment +
            "Device_guard/edit";
          let params = {
            token: window.localStorage.getItem("xnwfPcToken"),
            id: this.editDetail.id,
            device_id: this.ruleForm.device_id,
            user_id: this.ruleForm.user_id,
            price: this.ruleForm.price,
            new_price: this.ruleForm.new_price,
            pretty_price: this.ruleForm.pretty_price,
            is_default: this.ruleForm.is_default
          };
          // console.log(params);
          axios.post(url, params).then(res => {
            if (res.data.code == 200) {
              this.$emit("hideInEdit", true);
              this.$message.success("提交成功");
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  margin-top: 50px;
  .goodsList {
    td,
    th {
      border: 1px solid #ccc;
      padding: 4px 6px;
      font-size: 12px;
      line-height: 20px;
      img {
        width: 50px;
        height: 50px;
        object-fit: cover;
      }
    }
    .noData {
      border: 1px solid #ccc;
      td {
        border: none;
      }
    }
  }
}
</style>
